import { gql } from "@apollo/client"

const query = vars => gql`
  query CountByResult(
    $partner_id: Int
    $client_ids: [Int!]
  ) {
    normal: lens_kit_results_view_aggregate(
      where: {
        summary: {_eq: "normal"} 
        ${
          vars?.partner_id
            ? `enterprise_partner_id:{_eq:$partner_id}`
            : ""
        }
        ${
          vars?.client_ids
            ? `enterprise_client_id:{_in:$client_ids}`
            : ""
        }
      }
    ) {
      aggregate {
        count
      }
    }

    needs_review: lens_kit_results_view_aggregate(
      where: {
        summary: {_eq: "needs_review"} 

        ${
          vars?.partner_id
            ? `enterprise_partner_id:{_eq:$partner_id}`
            : ""
        }
        ${
          vars?.client_ids
            ? `enterprise_client_id:{_in:$client_ids}`
            : ""
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export default query
